import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--velotax-background-color);
  height: 100%;

  .sso-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    img {
      max-width: 350px;
      margin-bottom: 60px;
    }

    .sso-area {
      /* background: var(--veloprime-background-color); */
      border-radius: 8px;
      color: var(--white);
      padding: 20px;
      width: 500px;
      min-height: 100px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      h2 {
        margin-bottom: 20px;
        color: var(--veloprime-background-color);
      }

      .anticon {
        width: 40px;
        height: 40px;
        color: var(--veloprime-background-color);  

        svg {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
`;
